module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Boeztal_COA-9202495a0b99f19652ba7cb2fa079ee3.svg";